var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useRef } from 'react';
import { Button, FormField, Modal } from '../../shared';
import { services } from '../../../shared';
import { useForm } from 'react-hook-form';
import { questionType } from '../question-sets/question-type/question-type';
import { CASES } from '../../../config/routes';
import './autodecline-modal.scss';
export var AutoDeclineModal = function (_a) {
    var _b, _c, _d, _e;
    var show = _a.show, question = _a.question, questionSet = _a.questionSet, mainApplicant = _a.mainApplicant, workflowStep = _a.workflowStep, display = _a.display, rowPosition = _a.rowPosition, applicationApplicantId = _a.applicationApplicantId, caseId = _a.caseId, setMainValue = _a.setMainValue, setHideModal = _a.setHideModal, showHideQuestion = _a.showHideQuestion;
    var showHideClassName = show ? 'modal-ad display-block' : 'modal-ad display-none';
    var _f = useForm(), handleSubmit = _f.handleSubmit, register = _f.register, setValue = _f.setValue, errors = _f.errors, watch = _f.watch;
    var _g = useState(false), buttonVisible = _g[0], setButtonVisible = _g[1];
    var _h = useState(false), isReferWarningVisible = _h[0], setReferWarning = _h[1];
    var _j = useState(), autoDeclineAnswers = _j[0], setAutoDeclineAnswers = _j[1];
    var createInputId = function (applicantid, questionId, position) {
        return "".concat(applicantid, "-").concat(questionId, "-").concat(position);
    };
    var modalQuestion = useRef();
    var questionLists = useRef(questionSet.lists);
    var SmallListCode = 'AUTODECLINEMODALLIST';
    var idBlurNumber = 1000000;
    var answer = (_c = (_b = questionSet === null || questionSet === void 0 ? void 0 : questionSet.answers) === null || _b === void 0 ? void 0 : _b.find(function (answer) {
        return (question === null || question === void 0 ? void 0 : question.id) === answer.formSectionQuestionId &&
            answer.rowPosition === rowPosition &&
            answer.applicationApplicantId === applicationApplicantId;
    })) === null || _c === void 0 ? void 0 : _c.value;
    if (((_d = modalQuestion === null || modalQuestion === void 0 ? void 0 : modalQuestion.current) === null || _d === void 0 ? void 0 : _d.listTypeCode) == SmallListCode)
        answer = (parseInt(answer) + idBlurNumber).toString();
    var onSubmit = function (result) {
        var newValue = result[createInputId(applicationApplicantId, question === null || question === void 0 ? void 0 : question.id, rowPosition + 2)];
        if (modalQuestion.current.listTypeCode == SmallListCode) {
            newValue = (parseInt(newValue) - idBlurNumber).toString();
        }
        setMainValue(createInputId(applicationApplicantId, question === null || question === void 0 ? void 0 : question.id, rowPosition), newValue);
        var ans = questionSet.answers.find(function (autoDecline) { return autoDecline.autoDecline; });
        ans.autoDecline = false;
        ans.value = newValue;
        ans.autoRefer = autoDeclineAnswers.find(function (auto) {
            return auto.listsId.toString() === newValue.toString() && auto.formSectionQuestionId == ans.formSectionQuestionId;
        })
            ? true
            : false;
        setHideModal(true);
        if (question && showHideQuestion) {
            showHideQuestion(question.id, null, question.dataType == 'BOOL' ? newValue : null, question.dataType == 'LIST' ? Number(newValue) : null, applicationApplicantId);
        }
    };
    var declineCase = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.declineCase(caseId, workflowStep.formId)];
                case 1:
                    _a.sent();
                    window.location.href = "".concat(window.location.origin).concat(CASES.path);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchAutoDeclineAnswers = function (sectionId) { return __awaiter(void 0, void 0, void 0, function () {
        var autoDeclines;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(sectionId > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, services.getAutoDeclineAnswers(sectionId)];
                case 1:
                    autoDeclines = (_a.sent()).data;
                    setAutoDeclineAnswers(autoDeclines);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var getQuestionIdFromElementName = function (elName) {
        return Number(elName.split('-')[1]);
    };
    var inputModalBoolChangeHandler = function (e) {
        var _a, _b;
        var elementName = (_a = e === null || e === void 0 ? void 0 : e.currentTarget) === null || _a === void 0 ? void 0 : _a.name;
        var elementValue = (_b = e === null || e === void 0 ? void 0 : e.currentTarget) === null || _b === void 0 ? void 0 : _b.value;
        var elementListsId = Number(elementValue);
        var qId = getQuestionIdFromElementName(elementName);
        var matchedAutoDecline = autoDeclineAnswers === null || autoDeclineAnswers === void 0 ? void 0 : autoDeclineAnswers.find(function (q) { return q.formSectionQuestionId === qId; });
        var matched = !!matchedAutoDecline && elementValue
            ? (matchedAutoDecline === null || matchedAutoDecline === void 0 ? void 0 : matchedAutoDecline.value) === elementValue
            : elementListsId
                ? (matchedAutoDecline === null || matchedAutoDecline === void 0 ? void 0 : matchedAutoDecline.listsId) === elementListsId
                : false;
        setButtonVisible(!matched);
    };
    var inputModalListChangeHandler = function (e) {
        var _a, _b, _c, _d;
        var elementName = (_a = e === null || e === void 0 ? void 0 : e.currentTarget) === null || _a === void 0 ? void 0 : _a.name;
        var elementValue = (_b = e === null || e === void 0 ? void 0 : e.currentTarget) === null || _b === void 0 ? void 0 : _b.value;
        var elementListsId = Number(elementValue);
        var qId = getQuestionIdFromElementName(elementName);
        if (((_c = modalQuestion === null || modalQuestion === void 0 ? void 0 : modalQuestion.current) === null || _c === void 0 ? void 0 : _c.listTypeCode) == SmallListCode)
            elementListsId -= idBlurNumber;
        var matchedAnswer = {
            listsId: 0,
            formSectionQuestionId: 0,
            value: '',
            refer: false,
        };
        matchedAnswer = autoDeclineAnswers === null || autoDeclineAnswers === void 0 ? void 0 : autoDeclineAnswers.find(function (o) {
            return o.formSectionQuestionId == qId && (o.listsId === elementListsId || (o.listsId == 0 && o.value == elementValue));
        });
        setReferWarning((_d = matchedAnswer === null || matchedAnswer === void 0 ? void 0 : matchedAnswer.refer) !== null && _d !== void 0 ? _d : false);
        if (matchedAnswer != null || matchedAnswer != undefined) {
            setButtonVisible(matchedAnswer === null || matchedAnswer === void 0 ? void 0 : matchedAnswer.refer);
        }
        else {
            setButtonVisible(!matchedAnswer);
        }
    };
    useEffect(function () {
        var _a;
        fetchAutoDeclineAnswers(questionSet === null || questionSet === void 0 ? void 0 : questionSet.id);
        if (!!(questionSet === null || questionSet === void 0 ? void 0 : questionSet.lists) && ((_a = questionSet.lists[question === null || question === void 0 ? void 0 : question.listTypeCode]) === null || _a === void 0 ? void 0 : _a.length) < 6) {
            var lists = __assign({}, questionSet === null || questionSet === void 0 ? void 0 : questionSet.lists);
            modalQuestion.current = __assign(__assign({}, question), { listTypeCode: SmallListCode });
            var newList = __spreadArray([], lists[question === null || question === void 0 ? void 0 : question.listTypeCode], true);
            lists[SmallListCode] = newList.map(function (item) {
                return { value: item.value, id: item.id + idBlurNumber };
            });
            questionLists.current = lists;
        }
        else {
            questionLists.current = questionSet === null || questionSet === void 0 ? void 0 : questionSet.lists;
            modalQuestion.current = question;
        }
    }, [questionSet, question]);
    return (React.createElement(Modal, { show: show, handleClose: function () { return setHideModal(false); }, extendClass: "auto-decline-modal" },
        React.createElement("form", { onSubmit: handleSubmit(onSubmit) },
            React.createElement("fieldset", null,
                React.createElement("div", { className: "".concat(showHideClassName, " autodecline-modal") }),
                React.createElement("section", { className: "modal-main-ad" },
                    ' ',
                    React.createElement("p", { className: "modal-main-ad__decline-header" }, "Application Auto Decline"),
                    React.createElement("p", { className: "modal-main-ad__subheader" }, "Please review your answer to this question"),
                    React.createElement("div", { className: "modal-main-ad__question__wording" },
                        React.createElement(FormField, { label: question === null || question === void 0 ? void 0 : question.wording },
                            React.createElement("div", { className: "modal-main-ad__question" }, (modalQuestion === null || modalQuestion === void 0 ? void 0 : modalQuestion.current) &&
                                questionType((_e = mainApplicant === null || mainApplicant === void 0 ? void 0 : mainApplicant.id) !== null && _e !== void 0 ? _e : '0', applicationApplicantId, modalQuestion === null || modalQuestion === void 0 ? void 0 : modalQuestion.current, questionLists === null || questionLists === void 0 ? void 0 : questionLists.current, questionSet, rowPosition + 2, //so it doesn't match the row position of the question below
                                workflowStep, register, errors, setValue, inputModalBoolChangeHandler, inputModalListChangeHandler, watch, display(question), answer)))),
                    React.createElement("p", { className: "modal-main-ad__footer" }, "Due to your response to this question, we regret to inform you that we currently cannot accept your application. If this response was selected in error you are able to continue the application by amending the answer above."),
                    buttonVisible && (React.createElement("div", { className: "update-application-button" },
                        React.createElement(Button, { type: "submit", variant: "primary", size: "small", width: "full" }, "Update Application"))),
                    React.createElement(Button, { type: "button", variant: "secondary", size: "small", width: "full", onClick: declineCase }, "Cancel Application"))))));
};
